import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaginatedResults } from '../../models/paginated_results_model';
import { PaginationOptions } from '../../models/pagination_options';
import { Importer } from '../../models/importer';

@Injectable({
  providedIn: 'root',
})
export class ImporterService {
  currentDomain = environment.currentApiHostname
  apiUrl = `https://${this.currentDomain}/api/general`;

  constructor(private http: HttpClient) {}

  get(paginationOptions: PaginationOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
        `/importers?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }



  all() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<Importer>>(
      this.apiUrl +  `/importers/index/all`,
      options
    );
  }

  export(type: string, paginationOptions: PaginationOptions) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };


    return this.http.get(
      this.apiUrl +
        `/exports/importers/export/${type}?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }


  show(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Importer>(
      this.apiUrl +  `/importers/${uuid}`,
      options
    );
  }

  store(category: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<Importer>(
      this.apiUrl +  `/importers`,
      category,
      options
    );
  }

  update(category: any, uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<Importer>(
      this.apiUrl +  `/importers/update/${uuid}`,
      category,
      options
    );
  }
}
